import { z } from 'zod'

// The Rails API returns ids as JSON numbers; the app treats ids as strings.
// Accept either and normalize to string so inferred types stay `string`.
export const zId = z.union([z.string(), z.number()]).transform(String)
export const zIdNullable = z.union([z.string(), z.number()]).transform(String).nullable()

export const zListMeta = z.object({
  total: z.number(),
  page: z.number(),
  perPage: z.number(),
  totalPages: z.number(),
})
export type ListMeta = z.infer<typeof zListMeta>

export function listSchema<K extends string, T extends z.ZodTypeAny>(key: K, item: T) {
  return z.object({
    [key]: z.array(item),
    meta: zListMeta,
  } as { [P in K]: z.ZodArray<T> } & { meta: typeof zListMeta })
}

export const zApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    fields: z.record(z.array(z.string())).optional(),
  }),
})
export type ApiError = z.infer<typeof zApiError>

// ISO-8601 UTC timestamp, formatted app-side.
export const zIsoDate = z.string()

// Decimal returned by the API. Coerced: ActiveRecord serializes BigDecimal
// columns to a JSON *string* ("0.0") unless the serializer calls .to_f, and a
// strict z.number() would throw and blank the whole list. Coercion tolerates
// both the string and number forms so a missing .to_f can never silently break
// a screen again.
export const zDecimal = z.coerce.number()

// jsonb blobs keep their internal casing untouched (audit-log metadata).
export const zJsonBlob = z.record(z.unknown())
export type JsonBlob = z.infer<typeof zJsonBlob>
